module.exports = __webpack_public_path__ + "img/my-suppliers-icon.9c695668.svg";